<flowaccount-flowpay-intro></flowaccount-flowpay-intro>

<flowaccount-flowpay-good-point></flowaccount-flowpay-good-point>

<flowaccount-flowpay-qr-payment></flowaccount-flowpay-qr-payment>

<flowaccount-flowpay-third-party-payment></flowaccount-flowpay-third-party-payment>

<flowaccount-flowpay-video></flowaccount-flowpay-video>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'flowpay-faq'"
  [contentScully]="'flowpay-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-blog-swiper-squidex
  [customHeader]="{
    heading: 'BLOG_SWIPER_TOPIC.HEADING_FLOWPAY',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_FLOWPAY',
  }"
  [contentSquidex]="'flowpay-blog'"
  [contentScully]="'flowpay-blog-key'"
></flowaccount-blog-swiper-squidex>
